<template>
  <b-modal
    :id="`modal__${actionTitle}`"
    v-model="$show"
    class="modal__confirm"
    centered
    :title="`${actionTitle} Method Components Topic`"
    :footer-bg-variant="footerBgVariant"
    @hide="cancel"
  >
    <template>
      <p class="text__modal-body text__first">
        Are you sure that you want to {{ actionTitle.toLowerCase() }} this method components topic ?
        All of the information cannot be restored again.
      </p>
      <b-alert :show="actionTitle === 'Delete'" class="alert-text__method-title" variant="danger">
        <b class="text-danger"> {{ methodTitle }}</b>
      </b-alert>
      <p class="text__modal-body text__second">
        Click at the "{{ actionTitle }}" button to cancel this method components topic.
      </p>
    </template>
    <template #modal-footer>
      <b-button
        ref="button-cancel"
        variant="link"
        class="btn-link-dark button-cancel"
        @click="cancel()"
        >{{ textButton }}
      </b-button>
      <b-button
        ref="button-confirm"
        class="button-confirm"
        variant="danger"
        @click="clickConfirm(actionTitle)"
      >
        <span v-if="!isLoading"> {{ actionTitle }}</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  components: {},
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    actionTitle: {
      type: String,
      default: 'Cancel'
    },
    methodTitle: {
      type: String,
      default: 'Method Components Topic'
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    textButton() {
      return this.actionTitle === 'Cancel' ? 'Keep it' : 'Cancel';
    },
    $show: {
      get() {
        return this.showModal;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },
  methods: {
    clickConfirm(actionTitle) {
      this.$emit('confirmed', actionTitle);
    },

    cancel() {
      this.$emit('canceled');
    }
  }
};
</script>

<style lang="scss" scoped>
.text__modal-body {
  font-size: 14px;
  color: #6c757d;
}
</style>
